// @flow

import * as React from "react";
import { useDispatch } from "react-redux";

import actions from "../actions/";

const useInvertedNav = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(actions.invertNav());

        return function cleanup() {
            dispatch(actions.uninvertNav());
        };
    }, []); //eslint-disable-line
};

export default useInvertedNav;
